import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import UpperProgressBar from "../components/common-components/UpperProgressBar";
import RightSidebar from "../components/common-components/right_sidebar";
import StudenInfoThird from "../components/common-components/studentInfo/StudentThird";

const StudentInfo3 = () => {
    return (
        <div className="signup_pg">
            <Container fluid>
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <UpperProgressBar step={5} />

                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Additional Information</h2>
                                </div>
                                <StudenInfoThird Button={"Submit"}/>
                            </div>
                        </Col>
                        <RightSidebar step={5} />
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default StudentInfo3;
